
/* =========================================================
   FORMAT DATE AS YYYY-MM-DD
========================================================= */

export const formatDateKey = (dateValue) => {
  if (!dateValue) {
    return "";
  }

  if (
    typeof dateValue === "string" &&
    /^\d{4}-\d{2}-\d{2}$/.test(dateValue)
  ) {
    return dateValue;
  }

  const date = new Date(dateValue);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();

  const month = String(
    date.getMonth() + 1
  ).padStart(2, "0");

  const day = String(
    date.getDate()
  ).padStart(2, "0");

  return `${year}-${month}-${day}`;
};


/* =========================================================
   FORMAT RATE DATE
========================================================= */

export const formatRateDate = (dateValue) => {
  return formatDateKey(dateValue);
};


/* =========================================================
   DEFAULT RATE DATE
========================================================= */

export const getDefaultRateDate = () => {
  return formatRateDate(new Date());
};


/* =========================================================
   GET ALL CHARGED NIGHTS

   Check-in:  2026-09-03
   Check-out: 2026-09-05

   Returns:
   [
     "2026-09-03",
     "2026-09-04"
   ]
========================================================= */

export const getStayDates = (
  checkIn,
  checkOut
) => {
  const dates = [];

  if (!checkIn || !checkOut) {
    return dates;
  }

  const formattedCheckIn =
    formatDateKey(checkIn);

  const formattedCheckOut =
    formatDateKey(checkOut);

  if (
    !formattedCheckIn ||
    !formattedCheckOut
  ) {
    return dates;
  }

  const start = new Date(
    `${formattedCheckIn}T00:00:00`
  );

  const end = new Date(
    `${formattedCheckOut}T00:00:00`
  );

  if (
    Number.isNaN(start.getTime()) ||
    Number.isNaN(end.getTime()) ||
    start >= end
  ) {
    return dates;
  }

  const current = new Date(start);

  while (current < end) {
    dates.push(
      formatDateKey(current)
    );

    current.setDate(
      current.getDate() + 1
    );
  }

  return dates;
};
